import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const greynoise = defineConnector({
  identifier: "greynoise",
  name: "GreyNoise",
  tagLine: "Internet scanner intelligence",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.greynoise\\.io/.*",
  auth: (app) => headerAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [GreyNoise](https://www.greynoise.io/) and sign up for an account. Get your API key from the account settings page.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "GreyNoise API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.greynoise.io/ping",
  },
});
